 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"b3d329506d96541e9da8ce172a847912c03f749b","1":"e87b7acda5288085445089bbcb692c613f64a968","4":"component---src-pages-404-tsx","5":"component---src-pages-index-tsx","6":"component---src-pages-speaker-interviews-tsx","7":"component---src-pages-speakers-arthur-tsx","8":"component---src-pages-speakers-clark-tsx","9":"component---src-pages-speakers-ean-tsx","10":"component---src-pages-speakers-eason-tsx","11":"component---src-pages-speakers-fong-tsx","12":"component---src-pages-speakers-gelis-tsx","13":"component---src-pages-speakers-guo-de-xiang-tsx","14":"component---src-pages-speakers-huang-guan-rong-tsx","15":"component---src-pages-speakers-joao-rosa-tsx","16":"component---src-pages-speakers-juggernaut-tsx","17":"component---src-pages-speakers-kacper-gunia-tsx","18":"component---src-pages-speakers-kenny-baas-schwegler-tsx","19":"component---src-pages-speakers-kim-tsx","20":"component---src-pages-speakers-lee-meng-xuan-tsx","21":"component---src-pages-speakers-lin-de-zheng-tsx","22":"component---src-pages-speakers-lin-shi-pong-tsx","23":"component---src-pages-speakers-michael-suen-tsx","24":"component---src-pages-speakers-michael-tsx","25":"component---src-pages-speakers-nor-tsx","26":"component---src-pages-speakers-otto-tsx","27":"component---src-pages-speakers-paul-shih-tsx","28":"component---src-pages-speakers-rex-wang-tsx","29":"component---src-pages-speakers-richard-tsx","30":"component---src-pages-speakers-river-tsx","31":"component---src-pages-speakers-sam-huang-tsx","32":"component---src-pages-speakers-sylvia-tsx","33":"component---src-pages-speakers-teddy-chen-tsx","34":"component---src-pages-speakers-wang-wei-tsx","35":"component---src-pages-speakers-zeng-qi-da-tsx","36":"component---src-pages-speakers-zhang-yi-tsx","37":"component---src-pages-speakers-zhang-yun-wei-tsx","38":"component---src-pages-speakers-zheng-qi-wen-tsx","39":"component---src-pages-speaks-a-0900-tsx","40":"component---src-pages-speaks-a-1000-tsx","41":"component---src-pages-speaks-a-1100-tsx","42":"component---src-pages-speaks-a-1300-tsx","43":"component---src-pages-speaks-a-1400-tsx","44":"component---src-pages-speaks-a-1450-tsx","45":"component---src-pages-speaks-a-1530-tsx","46":"component---src-pages-speaks-b-0900-tsx","47":"component---src-pages-speaks-b-1000-tsx","48":"component---src-pages-speaks-b-1100-tsx","49":"component---src-pages-speaks-b-1300-tsx","50":"component---src-pages-speaks-b-1400-tsx","51":"component---src-pages-speaks-b-1450-tsx","52":"component---src-pages-speaks-b-1530-tsx","53":"component---src-pages-speaks-b-1710-tsx","54":"component---src-pages-speaks-c-0900-tsx","55":"component---src-pages-speaks-c-1000-tsx","56":"component---src-pages-speaks-c-1100-tsx","57":"component---src-pages-speaks-c-1300-tsx","58":"component---src-pages-speaks-c-1400-tsx","59":"component---src-pages-speaks-c-1450-tsx","60":"component---src-pages-speaks-c-1530-tsx","61":"component---src-pages-travel-guide-drive-tsx","62":"component---src-pages-travel-guide-mrt-tsx","63":"component---src-pages-workshops-a-0900-tsx","64":"component---src-pages-workshops-b-0900-tsx","65":"component---src-pages-workshops-c-0900-tsx","66":"component---src-pages-workshops-c-1300-tsx"}[chunkId]||chunkId) + "-" + {"0":"31d172b85b6e49717725","1":"b467f6170d7aaa791be5","4":"0db370abd2511957c468","5":"c5e0464389a4b40cee4e","6":"31404031d1921b2ed0e7","7":"368dda65edae1293f183","8":"bf0eb4c4cf387abc8200","9":"952497cfa041bf49f94e","10":"a2f7c0102b6bf5c36264","11":"01bf9da00286a09e3590","12":"b22c1e0634e578dc8181","13":"a945f38ac58ca13a3192","14":"67a8bef4c87bc4a6dda9","15":"d48ff552303a723ecc88","16":"d496afb961deacf79863","17":"a7afa752b1c28477713a","18":"66763c5a4a25730f9782","19":"5d9c765df8e8422fa6cc","20":"c70e19cc0f4fb53e51f9","21":"7a6ea5af4e86e0362097","22":"7cdce740ce61bec27a88","23":"b11b4163b6231578aa63","24":"d3bab0364851838c2556","25":"300908e6d1ce043de7f9","26":"fbee5b1a6ccbb94cfccb","27":"45876303edf0b0dc6f35","28":"93a961f7765db4b2e139","29":"32405a8184e261cbaac7","30":"5ddac67112b2912c8e41","31":"b0e2facf04eb373c5fdc","32":"98e1d271a8e1e2790d52","33":"1a831c5ab8d409708e54","34":"dfd7a6c483082d772a3a","35":"7be32ffb8003155a4aa7","36":"ecf20a9f7d4ad4c60324","37":"57fbbf2aa8f0597dcd96","38":"1926c7492cdff53c6614","39":"32e007a06f8fe0765d06","40":"bd8058d305517aed6b28","41":"494019dbc958da6a8595","42":"bbe558f213ec206fa197","43":"3d7098d10b6f323564b4","44":"b1995aa6bb0eaed33fbe","45":"e443ef590b82e6ad6e05","46":"2a841ba130e0bb360f5c","47":"bfd81015d8e413f4a62a","48":"0fa1e493a7b737af1bfd","49":"e9e8c83b2086044c569d","50":"f939c5c18398b5bd0556","51":"3462b0095cbd09b064a0","52":"550b6bd3b4a948e3dfd9","53":"838115c460a502fca7f1","54":"a1be3ca1758694241972","55":"8d315a070f0265b7cd5b","56":"af8c849a9ffd2d7e3d4a","57":"86eaffc15e954356472d","58":"ebbf433ef477f321111b","59":"90f2c06a08fcb5a5a6b3","60":"172e33be27cc00ed818e","61":"4cbddf67f1bf6cafbd06","62":"c9f4ab0d20d2e86e0ab1","63":"f2354f9f894b29a2b294","64":"282980df49c69dc72bce","65":"57eeaba180db5f3eb910","66":"b004690891745bc0cdb2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/2020/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
